import styled from 'styled-components';

export const Content = styled.div`
  box-sizing: border-box;
  position: absolute;
  left: ${(props) => props.left};
  top: ${(props) => props.top};
  min-width: 132px;
  padding: 8px 10px 8px 8px;
  background-color: #161e23;
  border: 1px solid #2c353d;
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.04),
    0 10px 24px rgba(0, 0, 0, 0.5);
  border-radius: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  cursor: ${(props) => (props.disabled ? 'default' : 'pointer')};
  transition:
    border-color 0.2s ease,
    box-shadow 0.2s ease;

  &:hover {
    border-color: ${(props) => (props.disabled ? '#2c353d' : '#3d4952')};
    box-shadow: ${(props) =>
      props.disabled
        ? 'inset 0 1px 0 rgba(255, 255, 255, 0.04), 0 10px 24px rgba(0, 0, 0, 0.5)'
        : 'inset 0 1px 0 rgba(255, 255, 255, 0.05), 0 12px 28px rgba(0, 0, 0, 0.55)'};
  }

  &.in-window {
    position: static;
    left: auto;
    top: auto;
    margin-right: 1px;
    min-width: 0;
    width: 125px;
    border-color: #2c353d;
    cursor: default;
    border-radius: 10px;
    padding: 6px;
    box-shadow: none;
    &:hover {
      border-color: #2c353d;
      box-shadow: none;
    }
    .zone-icon {
      height: 28px;
      width: 28px;
      border-radius: 8px;
      padding: 3px;
      b {
        width: 21px;
        font-size: 12px;
        border-radius: 6px;
      }
    }
  }
`;

/* Мини-дисплей: тёмная подложка-экранчик, на которой живут сегментные цифры. */
export const Display = styled.div`
  box-sizing: border-box;
  flex-shrink: 0;
  min-width: 58px;
  height: 40px;
  padding: 0 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #10151a;
  border: 1px solid ${(props) => (props.$empty ? '#2c353d' : '#243a30')};
  border-radius: 8px;
  box-shadow:
    inset 0 1px 4px rgba(0, 0, 0, 0.55),
    inset 0 0 0 1px rgba(0, 0, 0, 0.2);

  .in-window & {
    min-width: 52px;
    height: 34px;
    padding: 0 10px;
    border-radius: 7px;
    /* border-radius: 0;
    background: transparent;
    border: 0;
    box-shadow: none; */
  }
`;

export const Number = styled.div`
  font-family: 'IBM Plex Mono', monospace;
  font-variant-numeric: tabular-nums slashed-zero;
  font-weight: 600;
  font-size: 24px;     
  line-height: 1;
  letter-spacing: 2px;
  padding-left: 5px;
  text-align: center;
  color: ${(props) => (props.$empty ? '#5a666d' : '#5cc98a')};
  text-shadow: ${(props) => (props.$empty ? 'none' : '0 0 9px rgba(92, 201, 138, 0.35)')};

  .in-window & {
    font-size: 21px;
    letter-spacing: normal;
    font-weight: 500;
    padding-left: 0px;
  }
`;
